// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1MJbU","productName":"Table_productName__1lAfp"};